import React from 'react'

import { compose, withProps } from 'recompose'
import styled, { keyframes } from 'styled-components'

import { style } from 'theme'

type Props = {
  dots: number
  text: string
}

const dot = keyframes`
0% { opacity: 0; }
50% { opacity: 0.1; }
100% { opacity: 1; }
`

export const Text = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.38;
  color: ${style(theme => theme.colors.slate)};
`

export const Dot = styled.span<{ delay: number }>`
  font-size: 20px;
  margin-right: 1px;
  opacity: 0;
  font-weight: 600;
  animation: ${dot} 0.4s infinite;
  animation-delay: ${props => props.delay && `0.${props.delay}s`};
  animation-direction: alternate;
  &:first-child {
    margin-left: 1px;
  }
`

const enhance = compose<Props, Props>(
  withProps(({ dots }) => {
    // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
    // If you're here from the future, please resolve this ESLint error!
    // eslint-disable-next-line prefer-spread
    const dotsArray = Array.apply(null, Array(dots))
    return {
      dotsArray,
    }
  }),
)

const EllipsisText = props => (
  <Text>
    {props.text}
    {props.dotsArray.map((_, index) => {
      let delay = 0
      if (index !== 0) {
        delay = index + 1
      }
      return (
        <Dot key={index} delay={delay}>
          .
        </Dot>
      )
    })}
  </Text>
)

export default enhance(EllipsisText)
